import { type AxiosResponse } from 'axios';

import { get, post, put } from '@utilities';

export const fetchAllInspirations = async (body: Record<string, any>): Promise<AxiosResponse> => await post(`inspiration/all`, body);
export const addInspiration = async (body: Record<string, any>): Promise<AxiosResponse> => await post(`inspiration`, body);
export const fetchInspirationDetails = async (inspirationId: any): Promise<AxiosResponse> =>
	await get(`inspiration/${inspirationId}`, {});
export const fetchInspirationProductMapping = async (body: Record<string, any>): Promise<AxiosResponse> =>
	await post(`inspiration/inspiration_item_mapping/all`, body);
export const updateItemInclusionStatus = async (inspirationItemMappingId, body: any): Promise<AxiosResponse> =>
	await put(`inspiration/inspiration_item_mapping/${inspirationItemMappingId}`, body);
export const deleteInspirationItemMapping = async (body: Record<string, any>): Promise<AxiosResponse> =>
	await put(`inspiration/inspiration_item_mapping/delete`, body);
export const addInspirationItemMapping = async (inspirationId, body: any): Promise<AxiosResponse> =>
	await post(`inspiration/${inspirationId}/inspiration_item_mapping`, body);
export const deleteInspiration = async (inspirationId: any): Promise<AxiosResponse> =>
	await put(`inspiration/${inspirationId}/delete`, {});
export const fetchShortlistedInspirations = async (leadID: any): Promise<AxiosResponse> =>
	await get(`inspiration/shortlist/all?lead_id=${leadID}`, {});
export const shortlistInspiration = async (leadID,inspirationId: any): Promise<AxiosResponse> =>
	await post(`inspiration/shortlist`, {leadID,inspirationId});
export const removeShortlistedInspiration = async (inspirationId: any): Promise<AxiosResponse> =>
	await put(`inspiration/shortlist/delete`, inspirationId);
export const updateInspirationItem = async (inspirationItemId, body: any): Promise<AxiosResponse> =>
	await put(`inspiration/${inspirationItemId}`, body);
